import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  NgbPagination,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationPrevious
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { EverythingSearchService } from '../../everything-search.service';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';

@Component({
  selector: 'app-search-filter-pagination',
  templateUrl: './search-filter-pagination.component.html',
  styleUrls: [ './search-filter-pagination.component.scss' ],
  imports: [ NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast ]
})
export class SearchFilterPaginationComponent implements OnInit, OnDestroy {
  private container = inject(SearchParamsContainerComponent);

  @Input() total = 0;
  maxResults = inject(EverythingSearchService).maxResults;
  page = 1;
  subscription: Subscription;

  get collectionSize() {
    return Math.min(this.total, this.maxResults);
  }

  ngOnInit(): void {
    this.subscription = this.container.paramsChange.subscribe({
      next: params => this.page = params.page
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setPage(page: number) {
    if (typeof page === 'number' && !Number.isNaN(page) && page !== this.page) {
      this.container.setParams({ page });
    }
  }

}
